import { render, staticRenderFns } from "./ApprovalConfigurationForm.vue?vue&type=template&id=bcf7fed4&"
import script from "./ApprovalConfigurationForm.vue?vue&type=script&lang=js&"
export * from "./ApprovalConfigurationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports